import {
  View,
  Text,
  ActivityIndicator,
  TextInput
} from 'react-native'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import Card from '../../shared/card/Card'
import { Formik } from 'formik'
import CustomButton from '../../shared/button/Button'
import { globalStyles } from '../../../static/styles/global'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import { usePersonalStore } from '../../../stores/personalInfo'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import SelectKeyValue from '../../shared/form/SelectKeyValue'
import Toast from 'react-native-toast-message'
import * as yup from 'yup'
import { mapSelectValue } from '../../../utils'

const NcInformationForm = ({ navigation, route }: any) => {
    const { params } = route
    const {
        mostRecentUserOnBoardings: userId,
        mode,
        essUserOnBoardingKey,
        essUserOnBoardingFormKey
    } = params

    const { loading, postnconline } = useFormsStore()
    const initializestore = useInitializeStore()
    const personalstore = usePersonalStore()

    const intialValues = {
        filingstatus: '',
        additionalamount: '',
        totalAllowances: '',
        county: '',
        country: 'USA'
    }

    const w4schema = () => {
        const baseSchema = {
            filingstatus: yup.string().required('Filing Status is a required field'),
            additionalamount: yup.string().nullable(),
            totalAllowances: yup
                .string()
                .required('Total Allowances is a required field'),
            county: yup
                .string()
                .max(5, 'County cannot exceed 5 letters')
                .matches(/^[A-Za-z]+$/, 'Only letters are allowed')
                .required('County is a required field'),
            country: yup.string().nullable()
        }
        return yup.object(baseSchema)
    }
    const schema = w4schema()

    const options1 = [
        {
            key: 1,
            value: 'Single or Married Filing Separately'
        },
        { key: 2, value: 'Head of Household' },
        { key: 3, value: 'Married Filing Jointly or Surviving Spouse' }
    ]

    return (
        <KeyboardAwareScrollView
      enableOnAndroid={true}
      enableAutomaticScroll={true}
      enableResetScrollToCoords={false}
      keyboardShouldPersistTaps="handled"
      keyboardDismissMode="interactive"
      showsVerticalScrollIndicator={false}
      extraScrollHeight={80}
      contentContainerStyle={{ flexGrow: 1, paddingBottom: 20 }}
    >
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title={'NC Withholding Taxation '}
                    />
                </View>
            </View>
            <View style={globalStyles.containerOverlap}>
                <Formik
                    initialValues={{ ...intialValues }}
                    validationSchema={schema}
                    onSubmit={async (values, actions) => {
                        const data = {
                            entityId: personalstore?.personalData?.entityId,
                            essUserKey: initializestore?.initializeData?.userkey,
                            essObKey: essUserOnBoardingKey,
                            essUserOnBoardingFormKey: essUserOnBoardingFormKey,
                            completeOnline: mode == "online" ? true : false,
                            filingStatus: values?.filingstatus,
                            additionalAmount: values?.additionalamount
                                ? Number(values?.additionalamount)
                                : null,
                            totalAllowances: Number(values?.totalAllowances),
                            county: values?.county,
                            country: 'USA'
                        }

                        const response = await postnconline(data)
                        if (response?.success) {
                            if (mode === 'online') {
                                navigation.navigate('NcInformationOnline', {
                                    userId,
                                    mode,
                                    essUserOnBoardingKey,
                                    essUserOnBoardingFormKey,
                                    values
                                })
                            } else {
                                await Toast.show({
                                    type: 'success',
                                    position: 'bottom',
                                    text1: response?.message,
                                    visibilityTime: 3000,
                                    autoHide: true,
                                    topOffset: 60,
                                    onHide: () => {
                                        navigation.replace('OnboardingForms')
                                    }
                                })
                            }
                        } else {
                            await Toast.show({
                                type: 'error',
                                position: 'bottom',
                                text1: response?.message,
                                visibilityTime: 3000,
                                autoHide: true,
                                topOffset: 60
                            })
                        }
                    }}
                >
                    {(props) => (
                        <View>
                            <Card>
                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ width: '65%', justifyContent: 'center' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'Total number of allowances you are claiming *'}
                                        </Text>
                                    </View>
                                    <View style={{ width: '30%', overflow: 'hidden' }}>
                                        <TextInput
                                            style={[globalStyles.input, globalStyles.inputLight]}
                                            value={props.values.totalAllowances}
                                            keyboardType="numeric"
                                            onChangeText={(text) => {
                                                if (text === '' || /^\d+$/.test(text)) {
                                                    props.handleChange('totalAllowances')(text)
                                                }
                                            }}
                                        />
                                        {props.touched.totalAllowances &&
                                            props.errors.totalAllowances && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.totalAllowances}
                                                </Text>
                                            )}
                                    </View>
                                </View>

                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ width: '65%', justifyContent: 'center' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {
                                                'Additional amount, if any, you want withheld from each pay period (Enter whole dollars)'
                                            }
                                        </Text>
                                    </View>
                                    <View style={{ width: '30%', overflow: 'hidden' }}>
                                        <TextInput
                                            style={[globalStyles.input, globalStyles.inputLight]}
                                            value={props.values.additionalamount}
                                            keyboardType="numeric"
                                            onChangeText={(text) => {
                                                if (text === '' || /^\d+$/.test(text)) {
                                                    props.handleChange('additionalamount')(text)
                                                }
                                            }}
                                        />
                                        {props.touched.additionalamount &&
                                            props.errors.additionalamount && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.additionalamount}
                                                </Text>
                                            )}
                                    </View>
                                </View>

                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ justifyContent: 'center', width: '65%' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'Filing Status *'}
                                        </Text>
                                    </View>
                                    <View style={{ width: '30%', overflow: 'hidden' }}>
                                        <SelectKeyValue
                                            title="Filing Status"
                                            options={options1}
                                            selectedOption={mapSelectValue(
                                                options1,
                                                props.values.filingstatus
                                            )}
                                            onSelect={(option: any) => {
                                                props.setFieldValue('filingstatus', option - 1)
                                            }}
                                            textColor="primary"
                                        />
                                        {props.touched.filingstatus &&
                                            props.errors.filingstatus && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.filingstatus}
                                                </Text>
                                            )}
                                    </View>
                                </View>

                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ width: '65%', justifyContent: 'center' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'County (Enter first five letters) *'}
                                        </Text>
                                    </View>
                                    <View style={{ width: '30%', overflow: 'hidden' }}>
                                        <TextInput
                                            style={[globalStyles.input, globalStyles.inputLight]}
                                            value={props.values.county}
                                            onChangeText={(text) => {
                                                props.handleChange('county')(text)
                                            }}
                                        />
                                        {props.touched.county && props.errors.county && (
                                            <Text style={globalStyles.dangerAlert}>
                                                {props.errors.county}
                                            </Text>
                                        )}
                                    </View>
                                </View>

                                {/* <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ width: '65%', justifyContent: 'center' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {
                                                'Enter country'
                                            }
                                        </Text>
                                    </View>
                                    <View style={{ width: '30%', overflow: 'hidden' }}>
                                        <TextInput
                                            style={[globalStyles.input, globalStyles.inputLight]}
                                            value={props.values.country}
                                            keyboardType="numeric"
                                            onChangeText={(text) => {

                                                props.handleChange('country')(text)

                                            }}
                                        />
                                        {props.touched.country &&
                                            props.errors.country && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.country}
                                                </Text>
                                            )}
                                    </View>
                                </View> */}

                                {loading ? (
                                    <ActivityIndicator />
                                ) : (
                                    <View style={{ margin: 10 }}>
                                        <CustomButton
                                            text={mode === 'upload' ? 'Submit Information' : 'Next'}
                                            onPress={props.handleSubmit}
                                        />
                                    </View>
                                )}
                            </Card>
                        </View>
                    )}
                </Formik>
            </View>
        </KeyboardAwareScrollView>
    )
}

export default NcInformationForm
